import { Dispatch, SetStateAction, useState } from "react";


const useLoading = (initial: boolean = true): [boolean, (loading: boolean) => void] => {
    const [loading, setLoading] = useState(initial);

    return [loading, setLoading];
}

export default useLoading;